import FileCard from "./file-card-component";

export default function FilesGrid({ files, onRemoveFile, uploading }) {
  return (
    <section className="grid">
      {files.map((file) => (
        <FileCard
          key={file.id}
          file={file}
          onRemove={onRemoveFile}
          disabled={uploading}
        />
      ))}
    </section>
  );
}